/* eslint-disable no-undef */
import { API } from 'aws-amplify'
import * as queries from '@/graphql/queries'
import { getToday } from '@/mixins/today.mixin'
import { feed } from '@/api'

export default {
  state: {
    OPwidgetActive: false,
    strikeThresholds: ['5', '10', '15', '20'],
    selectedStrikeWidth: '10',
    selectedStockSymbol: '',
    selectedStockSymbolPrice: null,
    selectedExpDates: null,
    expDates: [],
    strikes: {},
    symbolsForSubscription: '',
    optionsCall: {},
    // Array of objects for rendering the Call table in the Option Chain widget
    optionsCallArr: [],
    optionsPut: {},
    // Array of objects for rendering the Put table in the Option Chain widget
    optionsPutArr: [],
    CallTableref: null,
    PutTableref: null,
    ScrollCallTable: false,
    ScrollPutTable: false,
    summary: null,
    trade: null,
    quote: null,
    greeks: null,
    summaryOP: null,
    tradeOP: null,
    quoteOP: null,
    greeksOP: null,
    subscribedSymbols: [],
    symbol_comp: [],
    optionUnderlying: null,
    closingOptionPosition: null,
    closingEquityPosition: null,
  },
  getters: {
    getOPwidgetActive: (state) => state.OPwidgetActive,
    getStrikeThresholds: (state) => state.strikeThresholds,
    getSelectedStrikeWidth: (state) => state.selectedStrikeWidth,
    getSelectedStockSymbol: (state) => state.selectedStockSymbol,
    getSelectedExpDates: (state) => state.selectedExpDates,
    getExpDates: (state) => state.expDates,
    getStrikes: (state) => state.strikes,
    getOptionsCall: (state) => state.optionsCallArr,
    getOptionsPut: (state) => state.optionsPutArr,
    getCallTableref: (state) => state.CallTableref,
    getPutTableref: (state) => state.PutTableref,
    getScrollCallTable: (state) => state.ScrollCallTable,
    getScrollPutTable: (state) => state.ScrollPutTable,
    getSummary: (state) => state.summary,
    getTrade: (state) => state.trade,
    getQuote: (state) => state.quote,
    getGreeks: (state) => state.greeks,
    getSummaryOP: (state) => state.summaryOP,
    getTradeOP: (state) => state.tradeOP,
    getQuoteOP: (state) => state.quoteOP,
    getsubscribedSymbols: (state) => state.subscribedSymbols,
    getsymbol_comp: (state) => state.symbol_comp,
    getOptionUnderlying: (state) => state.optionUnderlying,
    getClosingOptionPosition: (state) => state.closingOptionPosition,
    getClosingEquityPosition: (state) => state.closingEquityPosition,
  },
  mutations: {
    setClosingOptionPosition: (state, val) => {
      state.closingOptionPosition = val
    },
    setClosingEquityPosition: (state, val) => {
      state.closingEquityPosition = val
    },
    setOptionUnderlying: (state, val) => {
      state.optionUnderlying = val
    },
    setOPwidgetActive: (state, val) => {
      state.OPwidgetActive = val
    },
    setSelectedStrikeWidth: (state, val) => {
      // console.log('setSelectedStrikeWidth',val);
      state.selectedStrikeWidth = val
    },
    setCallTableref: (state, val) => {
      state.CallTableref = val
    },
    setPutTableref: (state, val) => {
      state.PutTableref = val
    },
    setScrollCallTable: (state, val) => {
      state.ScrollCallTable = val
    },
    setScrollPutTable: (state, val) => {
      state.ScrollPutTable = val
    },
    setSelectedStockSymbolPrice: (state, val) => {
      // console.log('setSelectedStockSymbolPrice',val);
      state.selectedStockSymbolPrice = val
    },
    setSelectedExpDates: (state, datesArr) => {
      // console.log('setSelectedExpDates', datesArr);
      state.selectedExpDates = datesArr
      state.strikes = {}
      state.symbolsForSubscription = ''
      state.optionsCall = {}
      state.optionsCallArr = []
      state.optionsPut = {}
      state.optionsPutArr = []
    },
    setSelectedStockSymbol: (state, selectedStockSymbol) => {
      // console.log('setSelectedStockSymbol',selectedStockSymbol);
      // reset all varables refered to the prior symbol
      state.selectedStockSymbol = ''
      state.selectedStockSymbolPrice = null
      state.selectedExpDates = []
      state.expDates = []
      state.strikes = {}
      state.symbolsForSubscription = ''
      state.optionsCall = {}
      state.optionsCallArr = []
      state.optionsPut = {}
      state.optionsPutArr = []
      // save symbol to the store
      state.selectedStockSymbol = selectedStockSymbol
    },
    retriveExpDates: (state, response) => {
      // let result = response.sort();
      // console.log("sorted dates list", result);
      // const currYear = new Date().getFullYear().toString().slice(2,4);
      // const options = { month: 'short'};

      // function chopper (string) {
      //   var year = string.slice(0,2);
      //   var month = string.slice(2,4)-1;
      //   var date = string.slice(4,6);
      //   return [year, month, date]
      // }

      const result = response.map((i) => {
        // const date = chopper(i);
        // if (date[0] === currYear){
        //   const getDate = new Date(Date.UTC(date[0],date[1], date[2]));
        //   return {value: i, text: getDate.toLocaleDateString('en-US', options) +" "+ date[2]}
        // } else {
        //   const expDate = new Date(Date.UTC(date[0], date[1], date[2]));
        //   return {value: i, text: expDate.toLocaleDateString('en-US', options) +" "+ date[2] + ", '" + date[0]}
        // }
        // const value = i.expiration.replaceAll('-','').slice(2)
        return { value: i.expiration, text: i.expiration }
      })
      state.expDates = result
    },
    retriveStrikes: (state, response) => {
      // console.log('retriveStrikes', response);
      let arr = response.map((i) => i.strike)
      arr.forEach((i) => Number(i))
      const result = arr.sort((a, b) => a - b)
      state.strikes = result
      // console.log('sorted strikes', result);
    },
    setSymbolsForSubscription: (state) => {
      // const value = i.expiration.replaceAll('-','').slice(2)
      const symboldate =
        state.selectedStockSymbol +
        state.selectedExpDates.replaceAll('-', '').slice(2)

      const call = state.strikes.map(
        (strike) => '.' + symboldate + 'C' + strike
      )
      const put = state.strikes.map((strike) => '.' + symboldate + 'P' + strike)
      // console.log('setSymbolsForSubscription',call);
      state.symbolsForSubscription = call.concat(put).toString()
      call.forEach((symbol) => {
        state.optionsCall[symbol] = { eventSymbol: symbol }
      })
      put.forEach((symbol) => {
        state.optionsPut[symbol] = { eventSymbol: symbol }
      })
    },
    setInitialOptionChain: (state, response) => {
      for (const event in response) {
        if (event == 'Quote' || event == 'Summary' || event == 'Trade') {
          for (const symbol in response[event]) {
            if (symbol in state.optionsCall) {
              Object.assign(state.optionsCall[symbol], response[event][symbol])
            }
            if (symbol in state.optionsPut) {
              Object.assign(state.optionsPut[symbol], response[event][symbol])
            }
          }
        }
      }
      state.optionsCallArr = Object.values(state.optionsCall)
      state.optionsPutArr = Object.values(state.optionsPut)
    },
    // setOptionChain: (state, liveData) => {
    //   // here we have formats applied for data of each type of events
    //   const formatQuote = (obj) => {
    //     obj['askExchangeCode'] = getExchangeOptions(obj['askExchangeCode']);
    //     obj['bidExchangeCode'] = getExchangeOptions(obj['bidExchangeCode']);
    //     obj['bidPrice'] = Number(obj['bidPrice']).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    //     obj['askPrice'] = Number(obj['askPrice']).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    //   }
    //   const formatTrade = (obj) => {
    //     obj['change'] = Number(obj['change']).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    //     obj['dayVolume'] = new Intl.NumberFormat('en-GB', { notation: "compact" }).format(obj['dayVolume']);
    //     obj['exchangeCode'] = getExchangeOptions(obj['exchangeCode']);
    //     obj['price'] = Number(obj['price']).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    //   }
    //   const formatSummary = (obj) => {
    //     obj['dayClosePrice'] == "NaN" ? obj['dayClosePrice'] = "-" : Number(obj['dayClosePrice']).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    //     obj['dayHighPrice'] == "NaN" ? obj['dayHighPrice'] = "-" : Number(obj['dayHighPrice']).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    //     obj['dayLowPrice'] == "NaN" ? obj['dayLowPrice'] = "-" : Number(obj['dayLowPrice']).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    //     obj['dayOpenPrice'] == "NaN" ? obj['dayOpenPrice'] = "-" : Number(obj['dayOpenPrice']).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    //     obj['prevDayClosePrice'] == "NaN" ? obj['prevDayClosePrice'] = "-" : Number(obj['prevDayClosePrice']).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    //   }
    //   // The service function to find symbol within the initial array and updata it with date fetched from the event
    //   // it takes three arguments:
    //   // 'symbol'- a symbol to update;
    //   // 'symbolObj' - an object with data fetched from the event;
    //   // 'designer' - a call back function to apply formats in accordance with the event type
    //   const eventDataDistributor = (symbol, symbolObj, designer) => {
    //     designer(symbolObj);
    //     const indexPut = state.optionsPutArr.findIndex(
    //       (item) => item.eventSymbol == symbol
    //     );
    //     const indexCall = state.optionsCallArr.findIndex(
    //       (item) => item.eventSymbol == symbol
    //     );
    //     if (indexPut != -1) {
    //       const optionObject = {
    //         ...state.optionsPutArr[indexPut],
    //         ...symbolObj,
    //       };
    //       state.optionsPutArr.splice(indexPut, 1, optionObject);
    //     } else if (indexCall != -1) {
    //       const optionObject = {
    //         ...state.optionsCallArr[indexCall],
    //         ...symbolObj,
    //       };
    //       state.optionsCallArr.splice(indexCall, 1, optionObject);
    //     }
    //   }
    //   // Out from here, we run the service function to update the initial array once live data has been received
    //   switch (Object.keys(liveData)[1]) {
    //     case "Quote":
    //       for (const symbol in liveData.Quote) {
    //         eventDataDistributor(symbol, liveData.Quote[symbol], formatQuote);
    //       }
    //       break;
    //     case "Trade":
    //       for (const symbol in liveData.Trade) {
    //         eventDataDistributor(symbol, liveData.Trade[symbol], formatTrade);
    //       }
    //       break;
    //     case "Summary":
    //       for (const symbol in liveData.Summary) {
    //         eventDataDistributor(symbol, liveData.Summary[symbol], formatSummary);
    //       }
    //   }
    // },
    // setSummary: (state, data) => {
    //   state.summary = data;
    // },
    // setQuote: (state, data) => {
    //     data.BidExchangeCode = ExchangeCodes[data.BidExchangeCode] || data.BidExchangeCode;
    //     data.AskExchangeCode = ExchangeCodes[data.AskExchangeCode] || data.AskExchangeCode;
    //   state.quote = data;
    // },
    // setTrade: (state, data) => {
    //   data.ExchangeCode = ExchangeCodes[data.ExchangeCode] || data.ExchangeCode;
    //   state.trade = data;
    // },
    // setGreeks: (state, data) => {
    //   state.greeks = data;
    // },
    // setSummaryOP: (state, data) => {
    //   state.summaryOP = data;
    // },
    // setQuoteOP: (state, data) => {
    //     data.BidExchangeCode = ExchangeCodes[data.BidExchangeCode] || data.BidExchangeCode;
    //     data.AskExchangeCode = ExchangeCodes[data.AskExchangeCode] || data.AskExchangeCode;
    //   state.quoteOP = data;
    // },
    // setTradeOP: (state, data) => {
    //   data.ExchangeCode = ExchangeCodes[data.ExchangeCode] || data.ExchangeCode;
    //   state.tradeOP = data;
    // },
    setsubscribedSymbols: (state, data) => {
      state.subscribedSymbols.push(...data)
      state.subscribedSymbols = Array.from(new Set(state.subscribedSymbols))
    },
    resetsubscribedSymbols: (state) => {
      state.subscribedSymbols = []
    },
    setsymbol_comp: (state, data) => {
      let findObj = state.symbol_comp.find((ele) => ele?.comp == data.comp)
      findObj
        ? findObj.symbols.push(...data.symbols)
        : state.symbol_comp.push({ comp: data.comp, symbols: data.symbols })
      if (findObj) {
        findObj.symbols = Array.from(new Set(findObj.symbols))
      }
    },
    reserSymbol_comp: (state, data) => {
      state.symbol_comp = data
    },
  },
  actions: {
    async fetchExpDates({ dispatch, commit }, symbol) {
      commit('setSelectedExpDates', [])
      dispatch('fetchStockPrice', symbol)
      try {
        const today = getToday()
        const response = await API.graphql({
          query: queries.listExpirations,
          variables: {
            symbol: symbol,
            limit: 1000,
            expiration: { ge: today },
          },
        })
        if (response.data.listExpirations.items.length > 0) {
          commit('setSelectedStockSymbol', symbol) // Don't move, setSelectedStockSymbol should be always before other mutations
          commit('retriveExpDates', response.data.listExpirations.items)
        }
      } catch (e) {
        console.error(e)
      }
    },
    async fetchStrikes({ symbol, expiration }) {
      try {
        console.log('fetchStrikes', symbol, expiration)
        const response = await API.graphql({
          query: queries.optionsByUnderlying,
          variables: {
            underlying: 'AAPL',
            expirationOptionTypeStrikeId: { ge: { expiration: expiration } },
          },
        })
        console.log('fetchStrikes', response)
        // commit('retriveStrikes', response.data.listOptions.items);
        // commit('setSymbolsForSubscription');
      } catch (e) {
        console.error('fetchStrikes', e)
      }
    },
    async fetchStockPrice({ commit }, symbol) {
      const response = await feed.getTrade(symbol)
      commit('setSelectedStockSymbolPrice', response)
    },
    async subscriptionReducer({ state, commit, dispatch }, expiration) {
      commit('setSelectedExpDates', expiration)
      const symbol = state.selectedStockSymbol
      const arg = { symbol, expiration }
      await dispatch('fetchStrikes', arg)
      await feed.getLastSnapshot(state.symbolsForSubscription)
      await feed.optionChainSubscribe(state.symbolsForSubscription)
    },
  },
}
